import { render, staticRenderFns } from "./AllTabsWithdraw.vue?vue&type=template&id=253513c4"
import script from "./AllTabsWithdraw.vue?vue&type=script&lang=js"
export * from "./AllTabsWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports